export default function CompanyInfo() {
  const companyDetails = [
    { label: '会社名', value: '有限会社ファーム建設' },
    { label: '創立', value: '昭和47年1月' },
    { label: '法人設立日', value: '昭和57年4月8日' },
    { label: '所在地', value: '神奈川県横浜市港北区篠原町1187-6' },
    { label: '加工所/資材置場', value: '神奈川県横浜市保土ヶ谷区菅田町1349-2' },
    { label: '代表取締役', value: '藤井大輔（専任宅地建物取引士）' },
    { label: '取締役', value: '藤井寅三（2級建築士）' },
    { label: '資本金', value: '500万円' }
  ];

  const businessContent = [
    '建設設計（プランニング・建築確認・管理）',
    '建築設計（在来・2×4・鉄骨・RC工法）',
    '不動産売買・仲介',
    '不動産賃貸・仲介',
    '不動産管理',
    '譲渡型賃貸住宅',
    'インテリアコーディネート（照明・家具等）',
    'リフォーム工事（増改築・水廻り・外構等）',
    '介護バリアフリー工事（手摺取付・段差解消等）',
    '中古品買取リサイクル販売',
    'ウォーターサーバーレンタル販売事業'
  ];

  const licenses = [
    { label: '建築業免許', value: '神奈川県知事免許 般～24第34635' },
    { label: '不動産免許', value: '神奈川県知事（2）第29900号' },
    { label: '古物商免許', value: '神奈川県公安委員会古物商許可業者 免許番号451450018950' }
  ];

  const qualifications = [
    '一級建築施工管理士',
    '二級建築士（2名）',
    '宅地建物取引士',
    '二級介護士',
    'インテリアコーディネーター',
    '福祉住環境コーディネーター',
    'リフォームスタイリスト'
  ];

  const banks = [
    'みずほ銀行/横浜駅前支店',
    '横浜信用金庫/新横浜支店'
  ];

  const partners = [
    '高橋屋株式会社',
    '株式会社平田タイル',
    '新日本興産株式会社',
    '有限会社横須賀トーヨー住器',
    'リアルアーツ株式会社'
  ];

  const organizations = [
    '（財）住宅保証機構',
    '住宅保証機構株式会社',
    '（公）神奈川県宅地建物取引業協会',
    '（公）全国宅地建物取引業保証協会 神奈川本部'
  ];

  return (
    <section id="company" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4">会社概要</h2>
          <p className="text-sm md:text-lg text-gray-600">創業43年の実績と信頼</p>
        </div>

        <div className="max-w-4xl mx-auto space-y-6 md:space-y-8">
          {/* 会社情報 */}
          <div className="bg-white rounded-2xl shadow-lg p-5 md:p-8 border border-gray-200">
            <h3 className="text-lg md:text-2xl font-bold text-gray-900 mb-4 md:mb-6 pb-3 md:pb-4 border-b-2 border-teal-500">会社情報</h3>
            <div className="space-y-3 md:space-y-4">
              {companyDetails.map((item, index) => (
                <div key={index} className="flex flex-col sm:flex-row border-b border-gray-100 pb-3 last:border-0">
                  <span className="text-gray-600 font-medium text-sm md:text-base sm:w-40 flex-shrink-0 mb-1 sm:mb-0">{item.label}</span>
                  <span className="text-gray-900 text-sm md:text-base">{item.value}</span>
                </div>
              ))}
            </div>
          </div>

          {/* 加盟団体 */}
          <div className="bg-white rounded-2xl shadow-lg p-5 md:p-8 border border-gray-200">
            <h3 className="text-lg md:text-2xl font-bold text-gray-900 mb-4 md:mb-6 pb-3 md:pb-4 border-b-2 border-teal-500">加盟団体</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3">
              {organizations.map((org, index) => (
                <div key={index} className="bg-gray-50 rounded-lg p-2 md:p-3">
                  <span className="text-gray-700 text-xs md:text-sm">{org}</span>
                </div>
              ))}
            </div>
          </div>

          {/* 許可・免許 */}
          <div className="bg-white rounded-2xl shadow-lg p-5 md:p-8 border border-gray-200">
            <h3 className="text-lg md:text-2xl font-bold text-gray-900 mb-4 md:mb-6 pb-3 md:pb-4 border-b-2 border-teal-500">許可・免許</h3>
            <div className="space-y-3 md:space-y-4">
              {licenses.map((item, index) => (
                <div key={index} className="flex flex-col sm:flex-row border-b border-gray-100 pb-3 last:border-0">
                  <span className="text-gray-600 font-medium text-sm md:text-base sm:w-32 flex-shrink-0 mb-1 sm:mb-0">{item.label}</span>
                  <span className="text-gray-900 text-sm md:text-base">{item.value}</span>
                </div>
              ))}
            </div>
          </div>

          {/* 資格 */}
          <div className="bg-white rounded-2xl shadow-lg p-5 md:p-8 border border-gray-200">
            <h3 className="text-lg md:text-2xl font-bold text-gray-900 mb-4 md:mb-6 pb-3 md:pb-4 border-b-2 border-teal-500">資格</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 md:gap-3">
              {qualifications.map((item, index) => (
                <div key={index} className="bg-gray-50 rounded-lg p-2 md:p-3 text-center">
                  <span className="text-gray-700 text-xs md:text-sm whitespace-nowrap">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
